import React, { useState, useEffect } from "react";
import clsx from "clsx";
import api from "../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Redirect } from "react-router-dom";

// MUI Components
import {
  CssBaseline,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  Badge,
  MenuItem,
  Menu,
  Collapse,
  Avatar,
} from "@material-ui/core";

import {
  Switch as SwitchRouter,
  withRouter,
  Route,
  Link,
} from "react-router-dom";

// MUI Icons
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import CategoryIcon from "@material-ui/icons/Category";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import StoreIcon from "@material-ui/icons/Store";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import SettingsIcon from "@material-ui/icons/Settings";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import AssistantPhotoIcon from "@material-ui/icons/AssistantPhoto";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ChatIcon from "@material-ui/icons/Chat";
import AssessmentIcon from "@material-ui/icons/Assessment";
import TuneIcon from "@material-ui/icons/Tune";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import ViewComfyIcon from "@material-ui/icons/ViewComfy";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import FiberPinIcon from "@material-ui/icons/FiberPin";
import FormatPaintIcon from "@material-ui/icons/FormatPaint";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import StorefrontIcon from "@material-ui/icons/Storefront";
import useStyles from "./styles";

// Page Components
import AdminAnalytics from "../AdminAnalytics/AdminAnalytics";

// User context
import { useUserContext, logoutUser } from "../../context/UserContext";

//////////////////////////////Admin Actions imports/////////////////////////////////////////////////////////////////
import AddAdmin from "../Pages/AdminActions/AddAdmin/AddAdmin";
import ViewAdmin from "../Pages/AdminActions/ViewAdmin/ViewAdmin";
import ProfileSettings from "../Pages/Settings/ProfileSettings/ProfileSettings";
import DashboardCustomization from "../Pages/Settings/Customizations/DashboardCustomization";
import ChangePassword from "../Pages/Settings/ChangePassword/ChangePassword";

//////////////////////////////Admin Actions on Buyers imports///////////////////////////////////////////////////////
import AddBuyer from "../Pages/BuyerActions/AddBuyer/AddBuyer";
import ViewBuyers from "../Pages/BuyerActions/ViewBuyers/ViewBuyers";
import logo from "../../assets/images/logo.png";

//////////////////////////////Admin Actions on Vendors imports///////////////////////////////////////////////////////
import ViewVendors from "../Pages/VendorActions/ViewVendors/ViewVendors";
import AddVendor from "../Pages/VendorActions/AddVendor/AddVendor";
import AddCategoryVendor from "../Pages/VendorActions/AddCategoryVendor/AddCategoryVendor";

//////////////////////////////Admin Actions on Products imports///////////////////////////////////////////////////////
import AddCategory from "../Pages/ProductActions/AddCategoryProduct/AddCategory";
import AddSubCategoryProduct from "../Pages/ProductActions/AddSubCategoryProduct/AddSubCategoryProduct";
import ViewProducts from "../Pages/ProductActions/ViewProducts/ViewProducts";

//////////////////////////////Admin Actions on Store imports///////////////////////////////////////////////////////
import ViewSellers from "../Pages/Sellers/ViewAllSellers/ViewAllSellers";

//////////////////////////////Admin Actions on Reports imports///////////////////////////////////////////////////////
import ViewReports from "../Pages/ViewReports/ViewReports";
import Orders from "../Pages/Orders/Orders";

import ViewAllStores from "../Pages/Stores/ViewAllStores/ViewAllStores";
import Reviews from "../Pages/Reviews/Reviews";
import AddOrderComplaintSubject from "../Pages/OrderComplaints/AddOrderComplaintSubject/AddOrderComplaintSubject";
import ViewOrderProbelms from "../Pages/OrderComplaints/ViewOrderProblems/ViewOrderProblems";
import Complaints from "../Pages/Complaints/Complaints";
import AddStore from "../Pages/Stores/AddStore/AddStore";
import AddSeller from "../Pages/Sellers/AddSeller/AddSeller";
import AddProductCard from "../Pages/ProductActions/AddProductCard/AddProductCard";
import AddProductVendor from "../Pages/ProductActions/AddProductVendor/AddProductVendor";
import AddProductStore from "../Pages/Stores/AddProductStore/AddProductStore";
import AddProductOfVendorToStore from "../Pages/Stores/AddProductOfVendorToStore/AddProductOfVendorToStore";
import ViewProductCard from "../Pages/ProductActions/ViewProductCard/ViewProductCard";
import ViewProductsOfStore from "../Pages/Stores/ViewProductsOfStore/ViewProductsOfStore";

const Layout = (props) => {
  const classes = useStyles();

  // context
  const { store, dispatch } = useUserContext();
  const token = store.data.token;
  const name = store.data.data.name;
  const profilePic = store.data.data.profilePic;
  const [dashboardLogo, setDashboardLogo] = useState("");

  // Current Path - URL Location
  const {
    location: { pathname },
  } = props;

  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    openn: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, openn } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, openn: false });
  };

  const retrivingDashboardLogo = async () => {
    await api
      .get("/superAdmin/adminPanel/logo", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setDashboardLogo(res?.data?.data?.logo);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error?.response?.data?.error))
      );
  };

  // navbar menu
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openProfile = Boolean(anchorEl);
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  ////////////////////////drawer handler functions///////////////////////////////
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  ////////////////////////Logout handler function/////////////////////////
  const logoutHandler = (e) => {
    e.preventDefault();

    api
      .post(
        "/superAdmin/logout",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        console.log("logging off");
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: You Have Logged Out Sucessfully!",
          openn: true,
        });
        setIsLoggedOut(true);
        return logoutUser(dispatch);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          message: "Server Coonection Error",
          type: "error",
          openn: true,
        });
      });
  };

  ///////////////////////////////// sidebar dropdowns////////////////////////

  const [openDDProduct, setOpenDDProduct] = useState(false);
  const [openDDSettings, setOpenDDSettings] = useState(false);
  const [openDDReports, setOpenDDReports] = useState(false);
  const [openDDVendors, setOpenDDVendors] = useState(false);
  const [openDDBuyers, setOpenDDBuyers] = useState(false);
  const [openDDAdmins, setOpenDDAdmins] = useState(false);
  const [openDDStore, setOpenDDStore] = useState(false);
  const [openDDSeller, setOpenDDSeller] = useState(false);
  ///////////dropdowns functions////////////////////////////////////////////
  const handleDDProduct = () => {
    setOpenDDProduct(!openDDProduct);
  };
  const handleDDSettings = () => {
    setOpenDDSettings(!openDDSettings);
  };
  const handleDDReports = () => {
    setOpenDDReports(!openDDReports);
  };
  const handleDDVendors = () => {
    setOpenDDVendors(!openDDVendors);
  };
  const handleDDStore = () => {
    setOpenDDStore(!openDDStore);
  };
  const handleDDBuyers = () => {
    setOpenDDBuyers(!openDDBuyers);
  };
  const handleDDAdmins = () => {
    setOpenDDAdmins(!openDDAdmins);
  };
  const handleDDSeller = () => {
    setOpenDDSeller(!openDDSeller);
  };

  // DARK MODE
  const [setMode] = useState(false);
  const modeType = localStorage.getItem("THEME_MODE");

  // dark mode handler
  const modeHandler = () => {
    if (!modeType) {
      localStorage.setItem("THEME_MODE", "dark");
      window.location.reload();
      console.log("set");
      setMode(true);
    } else {
      localStorage.removeItem("THEME_MODE");
      window.location.reload();
      console.log("removed");
      setMode(false);
    }
  };

  useEffect(() => {
    retrivingDashboardLogo();
    // eslint-disable-next-line
  }, []);

  return (
    // <Router>
    <div className={classes.root}>
      {isLoggedOut ? <Redirect to="/admin/login" /> : ""}
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            style={{ color: "grey" }}
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.appbarRight}>
            <div>
              <img src={logo} alt="Logo" className={classes.logo} />
            </div>
            <div>
              <Switch
                size="large"
                color="primary"
                icon={<Brightness4Icon color="primary" />}
                checkedIcon={<Brightness7Icon color="primary" />}
                checked={!!modeType}
                onChange={modeHandler}
              />
              <IconButton>
                <Badge badgeContent={3} color="primary">
                  <ChatIcon
                    fontSize="small"
                    style={{
                      color: "grey",
                    }}
                  />
                </Badge>
              </IconButton>
              <IconButton>
                <Badge badgeContent={9} color="primary">
                  <NotificationsIcon
                    fontSize="small"
                    style={{
                      color: "grey",
                    }}
                  />
                </Badge>
              </IconButton>

              <IconButton edge="end" aria-haspopup="true" onClick={handleMenu}>
                <Avatar alt={name.charAt(0)} src={profilePic} sizes="large" />
              </IconButton>
              <Menu
                id="menu-appbar"
                getContentAnchorEl={null}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                open={openProfile}
                onClose={handleClose}
              >
                <div style={{ margin: "10px 20px" }}>
                  <Typography variant="h5" weight="medium" color="secondary">
                    Hi, {name}
                  </Typography>
                </div>

                <MenuItem onClick={handleClose}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <StoreIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="View Profile" />
                </MenuItem>

                <MenuItem onClick={handleClose}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <AssistantPhotoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Report a Problem" />
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <LiveHelpIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Frequent Questions" />
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <ReportProblemIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Privacy Policy" />
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <SettingsIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Settings and Config" />
                </MenuItem>
                <MenuItem onClick={logoutHandler}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <ExitToAppIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Log Out" />
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {/* Drawer Open/Close Button */}
        <div className={classes.drawerHeader}>
          <IconButton
            onClick={handleDrawerClose}
            style={{ background: "rgba(50, 255, 250, 0.1)" }}
          >
            <ChevronLeftIcon style={{ color: "#FFF" }} />
          </IconButton>
        </div>

        {/* Drawer Menu List */}
        <List>
          <ListItem
            button
            component={Link}
            to="/admin/dashboard"
            selected={pathname === "/admin/dashboard"}
          >
            <ListItemIcon>
              <DashboardIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary={"1. Dashboard"} />
          </ListItem>

          <ListItem button onClick={handleDDVendors}>
            <ListItemIcon>
              <AccountBoxIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="2. Vendors" />
            {openDDVendors ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openDDVendors} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                className={classes.dropdown}
                button
                selected={pathname === "/admin/add-vendor-category"}
                component={Link}
                to="/admin/add-vendor-category"
              >
                <ListItemIcon>
                  <ViewComfyIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="2.1. Add Vendor Category" />
              </ListItem>
              <ListItem
                className={classes.dropdown}
                button
                selected={pathname === "/admin/add-vendors"}
                component={Link}
                to="/admin/add-vendors"
              >
                <ListItemIcon>
                  <PersonAddIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="2.2. Add Vendors" />
              </ListItem>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-vendors"}
                component={Link}
                to="/admin/view-vendors"
              >
                <ListItemIcon>
                  <SaveAltIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="2.3. View Vendors" />
              </ListItem>
            </List>
          </Collapse>

          <ListItem button onClick={handleDDSeller}>
            <ListItemIcon>
              <StoreIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="3. Seller" />
            {openDDSeller ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openDDSeller} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/add-seller"}
                component={Link}
                to="/admin/add-seller"
              >
                <ListItemIcon>
                  <SaveAltIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="3.1. Add Seller" />
              </ListItem>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-seller"}
                component={Link}
                to="/admin/view-seller"
              >
                <ListItemIcon>
                  <ViewCarouselIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="3.2. View Sellers" />
              </ListItem>
            </List>
          </Collapse>
          <ListItem button onClick={handleDDStore}>
            <ListItemIcon>
              <StorefrontIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="4. Store" />
            {openDDStore ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openDDStore} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/add-store"}
                component={Link}
                to="/admin/add-store"
              >
                <ListItemIcon>
                  <ViewCarouselIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="4.1. Add Store" />
              </ListItem>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-all-stores"}
                component={Link}
                to="/admin/view-all-stores"
              >
                <ListItemIcon>
                  <StorefrontIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="4.2. View Stores" />
              </ListItem>
            </List>
          </Collapse>

          <ListItem button onClick={handleDDProduct}>
            <ListItemIcon>
              <AddShoppingCartIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="5. Products" />
            {openDDProduct ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openDDProduct} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                className={classes.dropdown}
                button
                selected={pathname === "/admin/add-product-category"}
                component={Link}
                to="/admin/add-product-category"
              >
                <ListItemIcon>
                  <CategoryIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="5.2. Add Category of Product" />
              </ListItem>
              <ListItem
                className={classes.dropdown}
                button
                selected={pathname === "/admin/add-product-sub-category"}
                component={Link}
                to="/admin/add-product-sub-category"
              >
                <ListItemIcon>
                  <ViewComfyIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="5.3. Add Sub-Category of Product" />
              </ListItem>

              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/add-products"}
                component={Link}
                to="/admin/add-products"
              >
                <ListItemIcon>
                  <ViewComfyIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="5.4. Add Product" />
              </ListItem>
              <Snackbar
                open={openn}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-products"}
                component={Link}
                to="/admin/view-products"
              >
                <ListItemIcon>
                  <ViewCarouselIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="5.5. View Products" />
              </ListItem>
            </List>
          </Collapse>

          <ListItem button onClick={handleDDBuyers}>
            <ListItemIcon>
              <MonetizationOnIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="6. Buyers" />
            {openDDBuyers ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openDDBuyers} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                className={classes.dropdown}
                button
                selected={pathname === "/admin/add-buyer"}
                component={Link}
                to="/admin/add-buyer"
              >
                <ListItemIcon>
                  <PersonAddIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="6.1. Add Buyers" />
              </ListItem>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-buyers"}
                component={Link}
                to="/admin/view-buyers"
              >
                <ListItemIcon>
                  <ViewCarouselIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="6.2. View Buyers" />
              </ListItem>
            </List>
          </Collapse>
          <ListItem
            button
            selected={pathname === "/admin/orders"}
            component={Link}
            to="/admin/orders"
          >
            <ListItemIcon>
              <InboxIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="7. Orders" />
          </ListItem>
          <ListItem
            button
            selected={pathname === "/admin/reviews"}
            component={Link}
            to="/admin/reviews"
          >
            <ListItemIcon>
              <SpeakerNotesIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="8. Reviews" />
          </ListItem>
          <ListItem
            button
            selected={pathname === "/admin/complaints"}
            component={Link}
            to="/admin/complaints"
          >
            <ListItemIcon>
              <InboxIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="9. Complaints" />
          </ListItem>
          <ListItem button onClick={handleDDAdmins}>
            <ListItemIcon>
              <SupervisorAccountIcon className={classes.iconColor} />
            </ListItemIcon>

            <ListItemText primary="10. Admins" />
            {openDDAdmins ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openDDAdmins} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                className={classes.dropdown}
                button
                selected={pathname === "/admin/add-admin"}
                component={Link}
                to="/admin/add-admin"
              >
                <ListItemIcon>
                  <PersonAddIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="Add Admin" />
              </ListItem>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-admins"}
                component={Link}
                to="/admin/view-admins"
              >
                <ListItemIcon>
                  <ViewCarouselIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="View Admins" />
              </ListItem>
            </List>
          </Collapse>

          <ListItem button>
            <ListItemIcon>
              <ChatIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="11. Messages" />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
              <AssessmentIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="12. Business Analytics" />
          </ListItem>
          <ListItem button onClick={handleDDReports}>
            <ListItemIcon>
              <SupervisorAccountIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="13. Report And Feedback Section" />
            {openDDReports ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openDDReports} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                className={classes.dropdown}
                button
                selected={pathname === "/admin/add-order-subject"}
                component={Link}
                to="/admin/add-order-subject"
              >
                <ListItemIcon>
                  <ViewComfyIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="Add Order Complaint Subject" />
              </ListItem>
              {/* <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-reports"}
                component={Link}
                to="/admin/view-reports"
              >
                <ListItemIcon>
                  <SaveAltIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="System Complaints" />
              </ListItem> */}
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/view-order-complaints"}
                component={Link}
                to="/admin/view-order-complaints"
              >
                <ListItemIcon>
                  <SaveAltIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="Order Complaints" />
              </ListItem>
            </List>
          </Collapse>

          <ListItem button onClick={handleDDSettings}>
            <ListItemIcon>
              <TuneIcon className={classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="14. Settings" />
            {openDDSettings ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openDDSettings} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/setting/profile"}
                component={Link}
                to="/admin/setting/profile"
              >
                <ListItemIcon>
                  <SettingsIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="Profile Settings" />
              </ListItem>

              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/setting/profile/password"}
                component={Link}
                to="/admin/setting/profile/password"
              >
                <ListItemIcon>
                  <FiberPinIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="Change Password" />
              </ListItem>

              <ListItem
                button
                className={classes.dropdown}
                selected={pathname === "/admin/setting/dashboard"}
                component={Link}
                to="/admin/setting/dashboard"
              >
                <ListItemIcon>
                  <FormatPaintIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="Platform Customizations" />
              </ListItem>
            </List>
          </Collapse>
        </List>
      </Drawer>

      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <SwitchRouter>
          <Route
            path="/admin/add-vendor-category"
            component={AddCategoryVendor}
          />
          <Route path="/admin/add-seller" component={AddSeller} />
          <Route
            path="/admin/add-product-sub-category"
            component={AddSubCategoryProduct}
          />
          <Route
            path="/admin/setting/profile/password"
            component={ChangePassword}
          />
          <Route path="/admin/add-products" component={AddProductCard} />
          <Route path="/admin/add-product-category" component={AddCategory} />
          <Route path="/admin/add-vendors" component={AddVendor} />

          <Route path="/admin/view-admins" component={ViewAdmin} />
          <Route path="/admin/view-reports" component={ViewReports} />
          <Route path="/admin/view-seller" component={ViewSellers} />
          <Route path="/admin/view-all-stores" component={ViewAllStores} />
          <Route path="/admin/reviews" component={Reviews} />

          {/* <Route path="/admin/add-seller" component={Store} /> */}
          <Route path="/admin/add-store" component={AddStore} />
          <Route
            path="/admin/add-product-store-self"
            component={AddProductStore}
          />

          <Route path="/admin/add-buyer" component={AddBuyer} />
          <Route path="/admin/dashboard" component={AdminAnalytics} />
          <Route path="/admin/view-products" component={ViewProductCard} />
          <Route path="/admin/view-buyers" component={ViewBuyers} />
          <Route path="/admin/add-admin" component={AddAdmin} />
          <Route path="/admin/view-vendors" component={ViewVendors} />
          <Route path="/admin/setting/profile" component={ProfileSettings} />
          <Route
            path="/admin/setting/dashboard"
            component={DashboardCustomization}
          />
          <Route
            path="/admin/add-order-subject"
            component={AddOrderComplaintSubject}
          />
          <Route
            path="/admin/view-order-complaints"
            component={ViewOrderProbelms}
          />
          <Route path="/admin/complaints" component={Complaints} />
          <Route path="/admin/orders" component={Orders} />
          <Route
            path="/admin/add-product-vendor"
            component={AddProductVendor}
          />
          <Route
            path="/admin/add-product-store"
            component={AddProductOfVendorToStore}
          />
          <Route path="/admin/view-product-vendor" component={ViewProducts} />
          <Route
            path="/admin/view-product-store"
            component={ViewProductsOfStore}
          />
        </SwitchRouter>
      </main>
    </div>
  );
};

export default withRouter(Layout);
